<template>
<div id="pt350" class="pt350" v-cloak>
    <!-- パンくずリスト -->
    <breadcrumb :decriptPage="$t('pt350.labels.persForgotPass')" :topPageNm="'common.labels.login'"></breadcrumb>

    <div>
        <!-- パスワードを忘れた方へ -->
        <div class="itemTitle">
            <h2>{{$t('pt350.labels.persForgotPass')}}</h2>
        </div>
        <div class="section-inner">
            <!--初回表示時-->
            <div v-if="pt350ProcessType == ''">
                <!-- パスワードを忘れた方へ -->
                <h3 class="sectionTitle">{{$t('pt350.labels.persForgotPass')}}</h3>
                <p class="passSendInfo">
                    {{$t('pt350.labels.noteText[0]')}}<br>{{$t('pt350.labels.noteText[1]')}}
                </p>
                <div class="error-message" v-if="mailMessage3 !=''">
                    <p style="font-size:16px;">{{mailMessage3}}</p>
                </div>
                <p class="passSendMessage" v-if="mailMessage1 !='' || mailMessage2 !=''">
                    <span class="mailMessage1" v-if="mailMessage1 !=''" v-html="mailMessage1"></span>
                    <br v-if="mailMessage1 !='' && mailMessage2 !=''">
                    <span class="mailMessage2" v-if="mailMessage2 !=''" v-html="mailMessage2"></span>
                </p>
                <div class="passSendMail">
                    <span v-html="pt350Init.descriptionInfo['1']" />
                    <!-- Error area -->
                    <div>
                        <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="'pt350'"/> 
                    </div>
                    <!-- Error area -->

                    <div class="loginForm">
                        <dl>
                            <!--メールアドレス-->
                            <dt class="required">
                                <span id="kokyakuMail_lbl">{{$t('common.labels.mailAddress')}}</span>
                            </dt>
                            <dd>
                                <input-check v-model="pt350ReqModel.kokyakuMail" id="kokyakuMail" maxlength="100" type="text"/>
                            </dd>
                        </dl>
                    </div>
                    
                    <div class="passSendBtn">
                        <!-- メール送信する -->
                        <a class="btnSubmit" @click="pt350SendMail()">{{$t('pt350.buttons.sendMail')}}</a>
                    </div>
                </div>
                <!-- /mb32  -->
            </div>

            <div class="passSendFinish" v-if="pt350ProcessType == 1">
                <!-- 確認メール送信完了 -->
                <h3 class="sectionTitle">{{$t('pt350.labels.confirmMail[0]')}}</h3>
                <p class="passSendInfo">
                    <!-- ご入力いただいたメールアドレスにパスワード再発行手続きのメールを送信しました。 -->
                    {{$t('pt350.labels.confirmMail[1]')}}<br>
                    <!-- メールに記載されたURLをクリックしてご自身で新しいパスワードを設定してください。 -->
                    {{$t('pt350.labels.confirmMail[2]')}}
                </p>
                <p class="passSendMessage">
                    <!-- メールが到着しない場合は、ご入力いただいたメールアドレスが正しくない可能性がありますので、今一度お試しください。 -->
                    {{$t('pt350.labels.confirmMail[3]')}}
                </p>
                <div>
                    <!-- ※ログインする場合は -->
                    {{$t('pt350.labels.whenLogin')}}
                    <router-link :to="{ name: SiteConstants.PG010MAIN, query: {pageNo: 18}}"> {{$t('pt350.labels.here')}}</router-link>から<br>
                    <!-- ※新規にユーザー登録する場合は -->
                    <template v-if="firstAccessUseFlg == 0 && loginHissuFlg == 0">
                        {{$t('pt350.labels.registerNew')}}
                        <router-link :to="{ name: SiteConstants.PG010MAIN, query: {pageNo: 8}}">{{$t('common.labels.memberRegistration')}} {{$t('pt350.labels.here')}}</router-link>
                    </template>
                </div>
            </div>  
        </div>
        <!--section-inner  -->
    </div>
</div>
</template>

<script>
//import $ from 'jquery';
import common from 'assets/js/common';
import axios from "assets/js/request";
import Message from 'components/MessageEcSite';
import InputCheck from 'components/InputCheck';
import SiteConstants from 'assets/const/SiteConstants.json';
import Breadcrumb from "../commonParts/Breadcrumb.vue";

export default {
    name: "PT350PasswordSendAgain",
    props:{
        ptInitData: {
            type: Object,
            default: null,
        },
    },
    components: {
        InputCheck,
        Message,
        Breadcrumb
    },
    data() {
        return {
            listIdErr:[],
            listMessValid:[],
            mapMessValid:[],
            pt350ProcessType: '',
            pt350ReqModel:{
                kokyakuMail: null,
                kokyakuNo: null,
                kokyakuCd: null,
                tantoCd: null,
                btbFlg: null,
            },
            pt350Init:{
                descriptionInfo:{},
            },
           SiteConstants: SiteConstants,
           site: "",
           firstAccessUseFlg:0,
           mailMessage1:"",
           mailMessage2:"",
           mailMessage3:"",
           loginHissuFlg:0
        }
    },
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];

        if (_this.ptInitData){
            _this.pt350Init = _this.ptInitData;
            _this.firstAccessUseFlg = _this.ptInitData.firstAccessUseFlg;
            _this.loginHissuFlg = _this.ptInitData.loginHissuFlg;

            if(_this.pt350Init.descriptionInfo[2] != undefined){
                _this.mailMessage1 = _this.pt350Init.descriptionInfo[2];
                _this.mailMessage1 = _this.mailMessage1.replace("{0}",_this.pt350Init.siteMail)
            }

            if(_this.pt350Init.descriptionInfo[3] != undefined){
                _this.mailMessage2 = _this.pt350Init.descriptionInfo[3];
                _this.mailMessage2 = _this.mailMessage2.replace("{0}",_this.pt350Init.siteMail)
            }
            if (_this.pt350ReqModel.messageFlg == 1) {
                _this.mailMessage3 = _this.$t('pt360.labels.msgErrChangePassword');
            }
        }else{
            // eslint-disable-next-line
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT350 + _this.$UrlConstants.DO_INIT, _this.pt350ReqModel).then(function(response) {
                //TODO here
                _this.pt350Init = response.data;
                _this.firstAccessUseFlg = response.data.firstAccessUseFlg;
                _this.loginHissuFlg = response.data.loginHissuFlg;

                if(_this.pt350Init.descriptionInfo[2] != undefined){
                    _this.mailMessage1 = _this.pt350Init.descriptionInfo[2];
                    _this.mailMessage1 = _this.mailMessage1.replace("{0}",_this.pt350Init.siteMail)
                }

                if(_this.pt350Init.descriptionInfo[3] != undefined){
                    _this.mailMessage2 = _this.pt350Init.descriptionInfo[3];
                    _this.mailMessage2 = _this.mailMessage2.replace("{0}",_this.pt350Init.siteMail)
                }
                if (_this.pt350ReqModel.messageFlg == 1) {
                    _this.mailMessage3 = _this.$t('pt360.labels.msgErrChangePassword');
                }
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }
    },
    methods: {
        /*
        * Send mail
        */
        pt350SendMail: function(){
            var _this = this;
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr,'pt350');
            _this.$emit("event-loading", true);
            // Call API send mail doSendMail
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT350 + _this.$UrlConstants.DO_SEND_MAIL, _this.pt350ReqModel).then(function(response) {
                if(response.data.status == 'OK'){
                    _this.pt350ProcessType = 1;
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                // eslint-disable-next-line
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error,'pt350');
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        /*
        * Goto top page
        */
        pt350PageBack: function(){
            this.$router.push({name: this.SiteConstants.PG010MAIN, query:{pageNo:1}});
        },
        /*
        * Get length obj
        */
        getLengthObj: function(obj) {
            if(obj != undefined)
            return common.getLengthObj(obj);
        }
    },
    created(){
        var _this = this;
        // Get data from params and query
        var paramData = _this.$route.params;
        var queryData = _this.$route.query;
        
        if(Object.keys(paramData).length > 0){
            _this.pt350ReqModel = Object.assign({}, _this.pt350ReqModel, paramData);
        }

        if(Object.keys(queryData).length > 0){
            _this.pt350ReqModel = Object.assign({}, _this.pt350ReqModel, queryData);
        }
    }
}
</script>